// Manager for HEIC conversion
// Uses the bundled heic2any library for conversion

class HeicWorkerManager {
	async convert(arrayBuffer: ArrayBuffer): Promise<Blob> {
		// Dynamic import to avoid bundling if not needed
		const heic2any = (await import('heic2any')).default;
		const blob = new Blob([arrayBuffer], { type: 'image/heic' });

		const result = await heic2any({
			blob,
			toType: 'image/jpeg',
			quality: 0.85,
		});

		return Array.isArray(result) ? result[0] : result;
	}

	terminate(): void {
		// No-op, kept for API compatibility
	}
}

// Singleton instance
export const heicWorkerManager = new HeicWorkerManager();
